<div class="banner justify-content-center" role="banner">
  <h1 class="text-white">{{ 'contact.us.page.title' | translate }}</h1>
</div>

<fgbcl-contact-us></fgbcl-contact-us>
